module.exports = __webpack_public_path__ + "img/hr-cliff-sides.1461dba5.png";